import { Pagination, useIsMobile } from '@brunommsilva/react-foundations';
import {
  Box,
  Card,
  CardActions,
  CardHeader,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CategoriesList from '../components/categories/categories-list';
import CreateCategoryForm from '../components/categories/create-category-form';
import PageFab from '../components/page-fab/page-fab';
import useCategories from '../hooks/categories/use-categories';

const CategoriesPage = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const { categories, total, isLoading, hasError } = useCategories(
    page,
    perPage
  );

  const changePage = (newPage: number) => {
    setPage(newPage);
  };

  const changePerPage = (newPerPage: number) => {
    setPerPage(newPerPage);
    setPage(1);
  };

  const handleCreateSuccess = () => {
    setIsCreateDialogOpen(false);
  };

  const handleCreateCancel = () => {
    setIsCreateDialogOpen(false);
  };

  const renderCreateCategoryForm = () => {
    return (
      <CreateCategoryForm
        onSuccess={handleCreateSuccess}
        onCancel={handleCreateCancel}
      />
    );
  };

  const renderCategories = () => {
    return (
      <Card variant="outlined">
        <CardHeader
          title={
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {t('CATEGORIES')}
            </Typography>
          }
        />
        <Box sx={{ px: 2, pt: 2, pb: 1 }}>
          <CategoriesList
            categories={categories}
            isLoading={isLoading}
            isError={hasError}
          />
        </Box>
        <CardActions>
          <Grid
            container
            sx={{
              justifyContent: 'flex-end',
            }}
          >
            <Pagination
              page={page}
              perPage={perPage}
              total={total}
              onPageChange={changePage}
              onPerPageChange={changePerPage}
            />
          </Grid>
        </CardActions>
      </Card>
    );
  };

  return (
    <>
      <Grid container spacing={3}>
        {!isMobile && (
          <Grid
            size={{
              xs: 12,
              md: 4,
              lg: 3,
            }}
          >
            {renderCreateCategoryForm()}
          </Grid>
        )}
        <Grid
          size={{
            xs: 12,
            md: isMobile ? 12 : 8,
            lg: isMobile ? 12 : 9,
          }}
        >
          {renderCategories()}
        </Grid>
      </Grid>

      {isMobile && (
        <>
          <PageFab onClick={() => setIsCreateDialogOpen(true)} />
          <Dialog
            open={isCreateDialogOpen}
            onClose={handleCreateCancel}
            fullWidth
            maxWidth="xs"
          >
            <DialogTitle>{t('CREATE_NEW_CATEGORY')}</DialogTitle>
            <DialogContent>
              <CreateCategoryForm
                isDialog
                onSuccess={handleCreateSuccess}
                onCancel={handleCreateCancel}
              />
            </DialogContent>
          </Dialog>
        </>
      )}
    </>
  );
};

export default CategoriesPage;
